@if (isLoader) {
  <div>
    <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' TikTok'"></app-sidebar-header>
    <div class="tt-loader-container">
      <app-loader size="big"></app-loader>
    </div>
  </div>
} @else {
  <div class="h-100 overflow-auto crm-scroll tt-integration-container">
    <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' TikTok'"></app-sidebar-header>
    <mat-card class="shadow-none bg-transparent">
      <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
        <div class="header-container">
          <div class="icon-logo">
            <img src="/assets/svgs/integrations/tiktok.svg" alt="TikTok logo" />
          </div>
          <h5 class="tt-integration-description">{{ 'log_in_with_your_tiktok_account' | translate }}</h5>
        </div>
        <div class="pt-3">
          <p>{{ 'channel' | translate }}: {{ channel_name }}</p>
          <p>
            {{ 'status' | translate }}:
            @if (CHANNEL_STATUS_OBJECT[status]) {
              <span class="badge" [ngStyle]="{ 'background-color': CHANNEL_STATUS_OBJECT[status].color }">
                {{ 'channel_status_new.' + CHANNEL_STATUS_OBJECT[status].textKey | translate }}
              </span>
            }
          </p>
          <div class="d-flex gap-2 flex-wrap justify-content-center">
            @switch (status) {
              @case (CHANNEL_STATUS.CONNECTED) {
                <app-button btnType="stroked" (onChangeClick)="deleteChannel()">{{ 'delete' | translate }}</app-button>
              }
              @default {
                <app-button (onChangeClick)="connectAccount()">{{ 'connect' | translate }}</app-button>
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    @if (showQr) {
      <mat-card class="shadow-none bg-transparent">
        <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
          <div class="qr-code-container">
            <p class="qr-code-description">{{ 'open_link' | translate }}</p>
            <div class="d-flex gap-2 flex-wrap justify-content-center">
              <app-button (onChangeClick)="copyConnectUrlToClipboard()"
                >{{ 'copy_to_clipboard' | translate }}
              </app-button>
              <app-button (onChangeClick)="openWindow()">{{ 'open_link' | translate }}</app-button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (channel) {
      <div>
        <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">{{ 'information' | translate }}</h5>
            <app-button btnType="icon" (onChangeClick)="copyChannelId()" [matTooltip]="'copy_channel_id' | translate">
              <app-icon>content_copy</app-icon>
            </app-button>
          </div>
          <mat-divider class="mb-3"></mat-divider>
          <!-- Account Information -->
          @if (username || name) {
            <div class="mb-3">
              <h6 class="text-primary mb-2">{{ 'account' | translate }}</h6>
              @if (username) {
                <p class="mb-1 text-secondary">
                  {{ 'username' | translate }}: <span class="text-dark fw-500">{{ username }}</span>
                </p>
              }
              @if (name) {
                <p class="mb-1 text-secondary">
                  {{ 'name' | translate }}: <span class="text-dark fw-500">{{ name }}</span>
                </p>
              }
            </div>
          }
          <!-- Channel Details -->
          <div class="mb-3">
            <h6 class="text-primary mb-2">{{ 'channel_details' | translate }}</h6>
            <p class="mb-1 text-secondary">
              {{ 'channel_id' | translate }}:
              <span class="text-dark fw-500 font-monospace small">{{ channel.id }}</span>
            </p>
            <p class="mb-1 text-secondary">
              {{ 'type' | translate }}: <span class="text-dark fw-500">{{ channel.type }}</span>
            </p>
            <p class="mb-1 text-secondary">
              {{ 'created_at' | translate }}:
              <span class="text-dark fw-500">{{ channel.created_at | date: 'dd.MM.yyyy HH:mm' }}</span>
            </p>
            @if (channel.funnel_id) {
              <p class="mb-1 text-secondary">
                {{ 'funnel_id' | translate }}: <span class="text-dark fw-500">{{ channel.funnel_id }}</span>
              </p>
            }
            @if (channel.column_id) {
              <p class="mb-1 text-secondary">
                {{ 'column_id' | translate }}: <span class="text-dark fw-500">{{ channel.column_id }}</span>
              </p>
            }
          </div>
          <!-- Settings -->
          <div class="mb-3">
            <h6 class="text-primary mb-2">{{ 'settings' | translate }}</h6>
            <div class="d-flex gap-2 flex-wrap">
              <span class="badge" [ngClass]="channel.is_create_deal ? 'bg-success' : 'bg-secondary'">
                {{ 'is_create_deal' | translate }}:
                {{ channel.is_create_deal ? ('yes' | translate) : ('no' | translate) }}
              </span>
              <span class="badge" [ngClass]="channel.is_read_message ? 'bg-success' : 'bg-secondary'">
                {{ 'is_read_message' | translate }}:
                {{ channel.is_read_message ? ('yes' | translate) : ('no' | translate) }}
              </span>
              @if (channel.is_notification_delivery !== undefined) {
                <span class="badge" [ngClass]="channel.is_notification_delivery ? 'bg-success' : 'bg-secondary'">
                  {{ 'is_notification_delivery' | translate }}:
                  {{ channel.is_notification_delivery ? ('yes' | translate) : ('no' | translate) }}
                </span>
              }
            </div>
          </div>
          <!-- Additional Data (x_data) -->
          @if (xDataEntries.length > 0) {
            <div>
              <h6 class="text-primary mb-2">{{ 'additional_data' | translate }}</h6>
              <div class="table-responsive">
                <table class="table table-sm table-bordered">
                  <tbody>
                    @for (item of xDataEntries; track trackByXDataKey($index, item)) {
                      <tr>
                        <td class="text-secondary fw-500" style="width: 40%">{{ item[0] }}</td>
                        <td class="text-dark">
                          @if (isObject(item[1])) {
                            <pre class="mb-0 small">{{ item[1] | json }}</pre>
                          } @else {
                            {{ item[1] }}
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
        </mat-card-content>
      </div>
    }
    <app-integration-review
      [youtubeReviewLink]="'https://www.youtube.com/watch?v=EkbSMdgLTvw'"
    ></app-integration-review>
  </div>
}
